import { FC } from 'react'
import cn from './index.module.css'
import SecondaryButton, {
  ISecondaryButton,
} from '../SecondaryButton/SecondaryButton'
import classNames from 'classnames'

interface IPrimaryButton extends ISecondaryButton {}

const PrimaryButton: FC<IPrimaryButton> = ({ ...props }) => {
  return (
    <SecondaryButton
      {...props}
      className={classNames(cn.primaryButton, props.className)}
    />
  )
}

export default PrimaryButton
